import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { RolesService } from 'src/app/services/roles-service/roles.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-roles-rol-resume-card',
  templateUrl: './roles-rol-resume-card.component.html',
  styleUrls: ['./roles-rol-resume-card.component.scss']
})
export class RolesRolResumeCardComponent implements OnInit, OnDestroy {

  @Input() role;
  deleteRoleSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
              private rolesService: RolesService,
              private snackbarService: SnackBarService,
              private dialog: MatDialog,
              private router: Router) { }

  ngOnInit() {
  }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button')) {
      this.router.navigate(['/account/role', this.role.RoleInternalId]);
    }
  }

  public deleteRole() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['roles-page.delete role', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteRoleSubscription = this.rolesService.deleteRole(this.role.RoleInternalId).subscribe(
          (res) => {
            this.rolesService.refreshRoles();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public getSectionIcon(sectionId) {
    switch (sectionId) {
      case 'DSH':
        return 'fas fa-th';
      case 'TIC':
        return 'fas fa-receipt';
      case 'CEN':
        return 'fas fa-store-alt';
      case 'USE':
        return 'fas fa-users';
      case 'BRO':
        return 'fab fa-chromecast';
      case 'REP':
        return 'fas fa-file';
      case 'HEL':
        return 'fas fa-street-view';
      case 'COM':
        return 'fas fa-university';
      case 'DEV':
        return 'fas fa-microchip';
      case 'PRO':
        return 'fas fa-shopping-bag';
      case 'ROL':
        return 'fas fa-magic';
      case 'MCO':
        return 'fas fa-shopping-cart';
      case 'SMS':
        return 'fas fa-sms';
      case 'TUR':
        return 'fas fa-bookmark';
      case 'CTR':
        return 'fas fa-gamepad';
      case 'SES':
        return 'fas fa-hdd';
      case 'ACT':
        return 'fas fa-chart-line';
      case 'LEG':
        return 'fas fa-balance-scale-right';
      case 'GTW':
        return 'fas fa-cash-register';
      case 'CAT':
        return 'fas fa-book-open';
      case 'ORD':
        return 'fas fa-shopping-bag';
    }
  }

  ngOnDestroy() {
    if (this.deleteRoleSubscription) { this.deleteRoleSubscription.unsubscribe(); }
  }

}
